import { render, staticRenderFns } from "./Diligences.vue?vue&type=template&id=2721ec5c"
import script from "./Diligences.vue?vue&type=script&lang=js"
export * from "./Diligences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports